export default "__VITE_ASSET__UYTYkK4S__"